import { formatCents } from '../api';
import type { ProductCardData } from '../types';

interface Props {
  products: ProductCardData[];
  disabled: boolean;
  onAdd: (productId: string, quantity: number) => void;
}

/** Product cards render only from structured shop data, never from model text. */
export function ProductGrid({ products, disabled, onAdd }: Props) {
  if (products.length === 0) return null;

  return (
    <ul className="product-grid" aria-label="Gefundene Produkte">
      {products.map((product) => {
        const orderable = product.available !== false;
        return (
          <li className="product-card" key={product.productId}>
            {product.imageUrl && (
              <img
                src={product.imageUrl}
                alt=""
                loading="lazy"
                onError={(event) => {
                  event.currentTarget.hidden = true;
                }}
              />
            )}
            <span className="sku">Art.-Nr. {product.sku}</span>
            <span className="title">{product.title}</span>
            <span className="price">{formatCents(product.priceCents, product.currency)}</span>
            {!orderable && <span className="oos">Derzeit nicht bestellbar</span>}
            <button
              className="btn"
              type="button"
              disabled={disabled || !orderable}
              onClick={() => onAdd(product.productId, 1)}
            >
              In den Warenkorb
            </button>
          </li>
        );
      })}
    </ul>
  );
}
